import { generateJsxKey } from '@utils/ast';
import { CallToActionComponent } from './organism.cta.js';
import { jsx } from 'react/jsx-runtime';

const printCtaComponent = (node, context) => {
  return /*#__PURE__*/jsx(CallToActionComponent, {
    title: node.meta.title,
    isScrambled: node.pm2.isScrambled,
    columnCount: node.meta.columnCount,
    cards: node.cards
  }, generateJsxKey(context));
};
const ctaComponentJsxPrinters = {
  "cta-component": printCtaComponent
};

export { ctaComponentJsxPrinters, printCtaComponent };
//# sourceMappingURL=printer.to-jsx.js.map
